<template>
  <div class="rounded-lg mb-32">
    <div
      v-if="logoSrc"
      class="border-static-default-low rounded-t-lg border border-b-0 p-24"
    >
      <RevIllustration
        alt=""
        class="!h-[40px] w-auto"
        :height="40"
        :src="logoSrc"
        :width="498"
      />
    </div>
    <div
      class="bg-static-info-mid rounded-b-lg p-20"
      :class="{ 'rounded-lg': !logoSrc }"
    >
      <button class="flex w-full items-center" @click="onSellerClick">
        <div class="grow text-left">
          <div class="caption">{{ i18n(translations.sellerName) }}</div>
          <div class="body-2-bold">{{ seller.company }}</div>
        </div>
        <IconChevronRight />
      </button>
      <RatingInfo
        v-if="
          seller.ratesCount &&
          seller.rating?.value &&
          seller.ratesCount?.value &&
          seller.ratesCount.value > 0
        "
        class="mt-16"
        :rating="{
          averageRate: seller.rating.value,
          count: seller.ratesCount.value,
        }"
      />
    </div>
  </div>
  <SellerInfoModal :selected-offer="props.selectedOffer" />
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'

import type { GetPickersResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevIllustration } from '@ds/components/Illustration'
import { openModal } from '@ds/components/ModalBase'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import { MODAL_NAMES } from '~/scopes/product/pages/Product-JP/Product-JP.constants'
import { useSellerProductListPage } from '~/scopes/product-list/pages/SellerProductListPage/composables/useSellerProductListPage'
import RatingInfo from '~/scopes/reviews/reviews-display/components/Rating/Rating.vue'

import translations from './Seller.translations'
import SellerInfoModal from './components/SellerInfoModal/SellerInfoModal.vue'
import { BIG_SELLER_LOGO } from './seller.constants'

const props = defineProps<{
  selectedOffer: NonNullable<GetPickersResponse['selectedOffer']>
}>()

const { trackClick } = useTracking()
const i18n = useI18n()

const merchantId = ref('')

watch(
  () => props.selectedOffer,
  () => {
    merchantId.value = props.selectedOffer.merchant?.merchantId ?? ''
  },
  { deep: true, immediate: true },
)

const seller = useSellerProductListPage(merchantId)

const logoSrc = computed(() => {
  if (props.selectedOffer.merchant) {
    return BIG_SELLER_LOGO[props.selectedOffer.merchant.company]
  }

  return ''
})

function onSellerClick() {
  trackClick({
    zone: 'after_configuration',
    name: 'seller_info',
  })
  openModal(MODAL_NAMES.SELLER_INFO)
}
</script>
